import { render, staticRenderFns } from "./SolicitudBajaCliente.vue?vue&type=template&id=e84f0696&"
import script from "./SolicitudBajaCliente.vue?vue&type=script&lang=ts&"
export * from "./SolicitudBajaCliente.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudBajaCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports